import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import './style.scss';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { ButtonAppearance } from '~/view/components/Controls/ButtonComponent/types';
import { localeStore } from '~/mobx/localesStore';
import { modalStore } from '~/mobx/modalStore';
import { branchStore } from '~/mobx/branchStore';

interface IProps {
  integrationId: number;
  disabled?: boolean;
}

const T360BranchesMapping: React.FC<IProps> = observer((props: IProps) => {
  const handleClick = async () => {
    await t360IntegrationStore.loadAllTakerBranches();
    modalStore.openT360BranchesMappingModal({
      integrationId: props.integrationId,
      takerBranches: branchStore.branches,
      mappedBranches: t360IntegrationStore.integrationsSettingsTemp[props.integrationId]?.settings.branches_mapping ?? [],
      duplicates: new Set<string | number>(),
    });
  };

  return (
    <Button
      key={`${props.integrationId}-branches-mapping-settings`}
      className="t360-branches-mapping hidden"
      onClick={handleClick}
      disabled={props.disabled}
      appearance={ButtonAppearance.TERTIARY}
    >
      {localeStore.t('match_branches_btn')}
    </Button>
  );
});

export default T360BranchesMapping;
